import { CanActivateFn, createUrlTreeFromSnapshot } from '@angular/router';

import { usePermission } from '../composables/permission.composable';

import type { Feature } from '@sona/shared-model-common';

export const hasPermissionGuard = (permission: Feature): CanActivateFn => {
    return async (route) => {
        if (!usePermission(permission)()) {
            return createUrlTreeFromSnapshot(route, ['/forbidden']);
        }

        return true;
    };
};
